module.exports = __webpack_public_path__ + "static/media/icon-wifi-blue.f3e51556.svg";